<template>
  <!-- 公司信息 -->
  <div class="gsxx">
    <el-backtop></el-backtop>
    <div class="gsxx_header">
      <img
        style="width: 100%; height: 100%"
        src="../assets/cp/gsjj.png"
        alt=""
      />
    </div>
    <div class="gsjj">
      <div
        style="
          margin-top: 20px;
          margin-left: 20%;
          color: #d3d3d3;
          cursor: pointer;
        "
      >
        <span @click="tiaozhuan()">首页></span>
        <span style="color: black">公司简介</span>
      </div>
      <div class="bt" id="top1">
        <span>公司简介</span>
        <p>COMPANY PROFILE</p>
      </div>
      <div class="content">
        <p style="text-indent: 2em">
          江西惟一健康管理有限公司成立于2018年，是“健康促进驿站”的主体运营公司，项目专注重点服务于个体诊所、卫生室、综合门诊部、社区服务站等基层医疗卫生机构的B端客户，联合挂牌，并入“健康促进驿站”管理体系，实施协调管理、统一服务标准、统一品牌管理；线上+线下互融互促，共享医疗技术、康养养老、医护培训等资源，形成以社区为轴心的新型智慧“健联体”。
        </p>
      </div>
    </div>
    <div class="gsgc wow fadeInUp" data-wow-duration=".5s" id="top2">
      <div class="bt">
        <span>组织结构</span>
        <p>ORGANIZATION STRUCTURE</p>
      </div>

      <div class="card">
        <img height="450px" src="../assets/zzjg.png" alt="" />
      </div>
    </div>
    <div class="ywfw wow fadeInUp" data-wow-duration=".5s">
      <div class="bt">
        <span>业务范围</span>
        <p>SCOPE OF BUSINESS</p>
      </div>
      <div class="card">
        <div
          class="jtcard"
          @mouseover="changeIndex('1')"
          @mouseout="changeIndexBack('1')"
        >
          <img v-show="!show1" src="../assets/gy/01.png" />
          <img v-show="show1" src="../assets/gy/01-1.png" />
          <h3>01</h3>
          <p>医疗资源共享平台，<br />异地诊疗咨询、交流平台。</p>
          <div class="link">
            <div class="linkxz"></div>
          </div>
        </div>
        <div
          class="jtcard"
          @mouseover="changeIndex('2')"
          @mouseout="changeIndexBack('2')"
        >
          <img v-show="!show2" src="../assets/gy/02.png" />
          <img v-show="show2" src="../assets/gy/02-1.png" />
          <h3>02</h3>
          <p>术前术中术后的全程<br />护理，持有专业证<br />书的医护人员保驾护航<br />手术全过程。专业病种的<br />康复与护理。<br /></p>
          <div class="link">
            <div class="linkxz"></div>
          </div>
        </div>
        <div
          class="jtcard"
          @mouseover="changeIndex('3')"
          @mouseout="changeIndexBack('3')"
        >
          <img v-show="!show3" src="../assets/gy/03.png" />
          <img v-show="show3" src="../assets/gy/03-1.png" />
          <h3>03</h3>
          <p>确保疑难病症，早发现<br />早治疗。无忧看病。<br />天下赣医。全国异地就诊，<br />吃喝住行一条龙安排。</p>
          <div class="link">
            <div class="linkxz"></div>
          </div>
        </div>
        <div
          class="jtcard"
          @mouseover="changeIndex('4')"
          @mouseout="changeIndexBack('4')"
        >
          <img v-show="!show4" src="../assets/gy/04.png" />
          <img v-show="show4" src="../assets/gy/04-1.png" />
          <h3>04</h3>
          <p>根据病患的专业病<br />种类型，通过关键词<br />平台提供“药食同源”<br />的药食康复产品</p>
          <div class="link">
            <div class="linkxz"></div>
          </div>
        </div>
        <div
          class="jtcard"
          @mouseover="changeIndex('5')"
          @mouseout="changeIndexBack('5')"
        >
          <img v-show="!show4" src="../assets/gy/05.png" />
          <img v-show="show4" src="../assets/gy/05-1.png" />
          <h3>05</h3>
          <p>打造安全、便捷的<br />支付交易平台,由此可以延<br />伸出金融相关业务</p>
          <div class="link">
            <div class="linkxz"></div>
          </div>
        </div>
      </div>
      <div class="bt">
        <span>知识产权</span>
        <p>INTELLECTUAL PROPERTY</p>
      </div>
      <div class="card">
        <img src="../assets/gy/zlzs.png"/>
      </div>
      <Contact></Contact>
    </div>
  </div>
</template>
<script>
import WOW from "wowjs";
import Contact from "../components/ContactUs.vue";
import { selectbrief } from "@/api/patient.js";
export default {
  components: { Contact },
  name: "Home",
  data() {
    return {
      form: {
        name: "",
        region: "",
        desc: "",
      },
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      GCData: [],
      jjData: [],
      zjData: [],
    };
  },

  mounted() {
    this.$router.afterEach((to, from, next) => {
      if (to.params.lx == "公司简介") {
        setTimeout(() => {
          const TOP = document.getElementById("top1");
          const y = TOP.offsetTop;
          window.scrollTo({
            top: y,
            behavior: "smooth",
          });
        }, 1000);
      } else if (to.params.lx == "主要领导介绍") {
        setTimeout(() => {
          const TOP = document.getElementById("top2");
          const y = TOP.offsetTop;
          window.scrollTo({
            top: y,
            behavior: "smooth",
          });
        }, 1000);
      }
      // else if (to.params.lx == "专家顾问") {
      //   setTimeout(() => {
      //     window.scrollTo({
      //       top: 2200,
      //       behavior: "smooth",
      //     });
      //   }, 500);
      // }
    });
    this.getSelectbrief();
    setTimeout(() => {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 100,
        mobile: false,
        live: true,
      });
      wow.init();
    }, 200);
  },

  methods: {
    //获取专家
    getSelectbrief() {
      let data = new FormData();
      data.append("page", 1);
      data.append("rows", 100);
      data.append("dentity", "专家顾问");
      selectbrief(data).then((res) => {
        this.zjData = res.rows;
      });
    },
    changeIndex(e) {
      // 鼠标移入事件
      switch (e) {
        case "1":
          this.show1 = true;
          break;
        case "2":
          this.show2 = true;
          break;
        case "3":
          this.show3 = true;
          break;
        case "4":
          this.show4 = true;
          break;
      }
    },
    changeIndexBack(e) {
      // 鼠标移出事件
      switch (e) {
        case "1":
          this.show1 = false;
          break;
        case "2":
          this.show2 = false;
          break;
        case "3":
          this.show3 = false;
          break;
        case "4":
          this.show4 = false;
          break;
      }
    },
    tiaozhuan() {
      this.$router.push("/");
    },
  },

  watch: {
    "$store.state.rutset": {
      deep: true, //深度监听设置为 true
      handler: function (newVal, oldVal) {
        if (newVal == "公司简介") {
          setTimeout(() => {
            const TOP = document.getElementById("top1");
            const y = TOP.offsetTop;
            window.scrollTo({
              top: y,
              behavior: "smooth",
            });
          });
        } else if (newVal == "主要领导介绍") {
          setTimeout(() => {
            const TOP = document.getElementById("top2");
            const y = TOP.offsetTop;
            window.scrollTo({
              top: y,
              behavior: "smooth",
            });
          });
        }
        // else if (newVal == "专家顾问") {
        //   window.scrollTo({
        //     top: 2200,
        //     behavior: "smooth",
        //   });
        // }
      },
    },
  },
};
</script>
<style scoped>
>>> .el-input__inner {
  height: 60px;
}
</style>
<style lang="scss" scoped>
.gsxx {
  width: 100%;

  .ywfw {
    width: 100%;

    .card {
      display: flex;
      justify-content: center;
      align-items: center;

      .jtcard:hover {
        text-align: center;
        cursor: pointer;
        width: 265px;
        // height: 424px;
        background: #ffffff;
        margin: 20px;
        border-radius: 10px;

        // box-shadow: 0px 0px 10px 0px rgba(170,175,175,0.21);
        .link {
          margin: auto;
          width: 104px;
          height: 1px;
          border: solid 1px #317df6;
          text-align: center;

          .linkxz {
            width: 32px;
            height: 3px;
            margin: auto;
            background: #317df6;
          }
        }

        h3 {
          margin-top: 1px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #317df6;
        }

        p {
          margin-top: -10px;
          width: 265px;
          height: 161px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #317df6;
        }
      }

      .jtcard {
        text-align: center;
        width: 265px;
        cursor: pointer;
        // height: 424px;
        background: #ffffff;
        margin: 20px;
        border-radius: 10px;

        // box-shadow: 0px 0px 10px 0px rgba(170,175,175,0.21);
        .link {
          margin: auto;
          width: 104px;
          height: 1px;
          border: solid 1px #404040;
        }

        h3 {
          margin-top: 1px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #171717;
        }

        p {
          margin-top: -10px;
          width: 265px;
          height: 161px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
        }
      }
    }

    .bt {
      padding-top: 70px;
      text-align: center;

      span {
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }

      p {
        margin-top: 5px;
        margin-bottom: 20px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }

    .zjgw {
      width: 1160px;
      height: 279px;
      margin: auto;
      margin-top: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      background: #ffffff;
      border-radius: 10px;

      // box-shadow: 0px 0px 10px 0px rgba(145, 151, 151, 0.21);
      .tx {
        width: 213px;
        height: 279px;
        text-align: center;
      }

      .content {
        width: 921px;
        height: 260px;
        text-align: left;
        // font-size: 12px;
        // font-family: Microsoft YaHei;
        // font-weight: bold;
        // color: #333333;
        line-height: 16px;
      }
    }
  }

  .gsgc {
    height: 42.5rem;
    // opacity: 0.4;
    background: #0044ce;
    background-image: url(../assets/gy/9436aea7046b33186f82c55968d8659.png);
    background-size: 100%, 100%;
    background-size: cover;
    background-repeat: no-repeat;

    .card {
      display: flex;
      justify-content: center;
      align-items: center;

      .jtcard {
        width: 281px;
        height: 424px;
        background: #ffffff;
        margin-top: 30px !important;
        margin: 50px;
        border-radius: 10px;
        box-shadow: 0px 0px 10px 0px rgba(170, 175, 175, 0.21);

        h3 {
          margin-left: 20px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #171717;
        }

        p {
          margin-top: -10px;
          margin-left: 20px;
          margin-right: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #676767;
        }
      }
    }

    .bt {
      padding-top: 70px;
      text-align: center;

      span {
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
      }

      p {
        margin-top: 5px;
        margin-bottom: 20px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }

  .gsxx_header {
    width: 100%;
    height: 407px;
    // background-image: url(../assets/gy/cd2522fe6c8b4a866dc3f254fe557baf.png);
    // background-size: 100%, 100%;
    // background-size: contain;
    // background-repeat: no-repeat;
  }

  .content {
    margin: auto;
    width: 1006px;
    // height: 55px;
    margin-bottom: 100px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #656565;
    text-align: left;
  }

  .gsjj {
    width: 100%;
    // height: 550px;

    .card {
      display: flex;
      justify-content: center;
      align-items: center;

      .jtcard {
        width: 200px;
        height: 250px;
        margin: 20px;
        border-radius: 10px;
        // box-shadow: 0px 0px 10px 0px rgba(170,175,175,0.21);
        text-align: center;

        h3 {
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #171717;
        }

        p {
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #676767;
        }
      }
    }

    .bt {
      padding-top: 70px;
      text-align: center;

      span {
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }

      p {
        margin-top: 5px;
        margin-bottom: 20px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }
  }
}
</style>
